import type { IApplicationDetails } from '@/features/ApplicationForm/types';
import ApplicationInformationDetails from './AppicationInformationDetails';
import HouseholdIncomeDetails from './HouseholdIncomeDetails';

export const ApplicationDetails = ({ applicationData }: IApplicationDetails) => {
  return (
    <>
      <ApplicationInformationDetails applicationInformation={applicationData.application} />
      <HouseholdIncomeDetails householdIncome={applicationData?.householdIncome} />
    </>
  );
};
